﻿import document from 'document';

export const requestPrice = () => {

    const init = () => {
        var targetsElements = getTargetElements();
        function getTargetElements() {
            var radio = document.getElementsByName('IsDeposit');
            var text = document.getElementById('Deposit');
            for (var i = 0; i < radio.length; i++) {
                radio[i].addEventListener("click", radioClick);
            }
            return {
                'radio': radio,
                'text': text,
            };
        }
        function radioClick(evt) {
            if (evt.target.id === 'IsDepositYes') {
                targetsElements.text.disabled = false;
                targetsElements.text.required = true;
            }
            else {
                targetsElements.text.disabled = true;
                targetsElements.text.required = false;
                targetsElements.text.value = '';
            }
        }
    };

    return {
        init,
    };
};